var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreentime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47.2982,
    height: 47.2982,
    rx: 14.1895,
    fill: "#212121",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5509 29.2063L29.2063 27.5509L24.8312 23.1758V17.7365H22.4663V24.1218L27.5509 29.2063ZM23.6488 35.4733C22.013 35.4733 20.4759 35.1628 19.0372 34.5416C17.5985 33.9212 16.3471 33.0789 15.2829 32.0147C14.2187 30.9504 13.3764 29.699 12.756 28.2604C12.1348 26.8217 11.8242 25.2845 11.8242 23.6488C11.8242 22.013 12.1348 20.4759 12.756 19.0372C13.3764 17.5985 14.2187 16.3471 15.2829 15.2829C16.3471 14.2187 17.5985 13.376 19.0372 12.7548C20.4759 12.1344 22.013 11.8242 23.6488 11.8242C25.2845 11.8242 26.8217 12.1344 28.2604 12.7548C29.699 13.376 30.9504 14.2187 32.0147 15.2829C33.0789 16.3471 33.9212 17.5985 34.5416 19.0372C35.1628 20.4759 35.4733 22.013 35.4733 23.6488C35.4733 25.2845 35.1628 26.8217 34.5416 28.2604C33.9212 29.699 33.0789 30.9504 32.0147 32.0147C30.9504 33.0789 29.699 33.9212 28.2604 34.5416C26.8217 35.1628 25.2845 35.4733 23.6488 35.4733ZM23.6488 33.1084C26.2699 33.1084 28.502 32.1873 30.345 30.345C32.1873 28.502 33.1084 26.2699 33.1084 23.6488C33.1084 21.0277 32.1873 18.7956 30.345 16.9525C28.502 15.1103 26.2699 14.1891 23.6488 14.1891C21.0277 14.1891 18.796 15.1103 16.9537 16.9525C15.1107 18.7956 14.1891 21.0277 14.1891 23.6488C14.1891 26.2699 15.1107 28.502 16.9537 30.345C18.796 32.1873 21.0277 33.1084 23.6488 33.1084Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreentime);
export default __webpack_public_path__ + "static/media/greentime.d1484b1b09ef0f3207a87b7cd0c961f5.svg";
export { ForwardRef as ReactComponent };